import { render, staticRenderFns } from "./Anwesenheit.vue?vue&type=template&id=30311b4a&"
import script from "./Anwesenheit.vue?vue&type=script&lang=js&"
export * from "./Anwesenheit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports